export enum SolveStatus {
    NotSolved = 0,
    Solved
  }
  